
export default {
    
    approverName: state => () => state.approvers.filter((a) => a.priority === 1)[0],

    employeeFiledLoans: state => (employeeFiledLoansId) =>  {
        return state.employeeFiledLoans.find(u => u.employeeFiledLoansId === employeeFiledLoansId)
    }
    

}